import commonUtil from "../../../util/common-utils";
import { ChipPickerDom } from "./chip-picker-dom";

export interface ChipPickerRenderOptions {
    chipClass?: string;
    labelClass?: string;
    removeClass?: string;
    idAttribute?: string;
    removeAction?: string;
    removeAriaLabel?: string;
    hideUnknownLabels?: boolean;
    labelIsHtml?: boolean;
    emptyHtml?: string;
}

export interface ChipPickerRenderItem {
    id: string;
    label: string;
}

export interface ChipPickerRenderParams {
    rootEl: HTMLElement;
    items: ChipPickerRenderItem[];
    options?: ChipPickerRenderOptions;
}

export class ChipPickerRender {
    public static setClearButtonsLabel(rootEl: ParentNode, label: string): void {
        const buttons = ChipPickerDom.getClearButtons(rootEl);
        buttons.forEach((button) => {
            button.textContent = label;
        });
    }

    public static render(params: ChipPickerRenderParams): void {
        const { rootEl, items, options } = params;

        const list = Array.isArray(items) ? items : [];
        if (list.length === 0) {
            rootEl.innerHTML = String(options?.emptyHtml || "");
            return;
        }

        const chipClass = String(options?.chipClass || "chip");
        const labelClass = String(options?.labelClass || "chip__label");
        const removeClass = String(options?.removeClass || "chip__remove");
        const idAttribute = String(options?.idAttribute || "data-item-id");
        const removeAction = String(options?.removeAction || "remove");
        const removeAriaLabel = String(options?.removeAriaLabel || "Remove");
        const labelIsHtml = options?.labelIsHtml === true;

        rootEl.innerHTML = list
            .map(
                (item) => `
            <span class="${commonUtil.escapeHtmlAttribute(chipClass)}" ${commonUtil.escapeHtmlAttribute(
                idAttribute,
            )}="${commonUtil.escapeHtmlAttribute(item.id)}">
                <span class="${commonUtil.escapeHtmlAttribute(labelClass)}">${
                    labelIsHtml ? String(item.label || "") : commonUtil.escapeHtml(String(item.label || ""))
                }</span>
                <button type="button" class="btn circle-clear ${commonUtil.escapeHtmlAttribute(
                    removeClass,
                )}" data-action="${commonUtil.escapeHtmlAttribute(removeAction)}" aria-label="${commonUtil.escapeHtmlAttribute(
                    removeAriaLabel,
                )}"></button>
            </span>
        `,
            )
            .join("");
    }
}
